import { combineReducers, Reducer } from "redux";

import { EMPTY_ARRAY, EMPTY_OBJECT } from "@multiweb/reactUtils";
import { ILanguageExtended } from "@multiweb/types/contracts";
import { TypedObject } from "@multiweb/types/react";
import { IClearLocalizationItemsAction, IConcatLocalizationItemsAction, Ii18nState, ISetLocaleCodeAction, ISetSupportedLanguagesAction, LocalizationItem } from "./types";

const localeCode: Reducer<string> = (state = "cs", action) => {
    if (action instanceof ISetLocaleCodeAction) {
        return action.payload.localeCode;
    } else {
        return state;
    }
};

const supportedLanguages: Reducer<readonly ILanguageExtended[]> = (state = EMPTY_ARRAY, action) => {
    if (action instanceof ISetSupportedLanguagesAction)
        return action.payload.supportedLanguages;
    return state;
};

export const localizationItems: Reducer<TypedObject<LocalizationItem>> = (state = EMPTY_OBJECT, action) => {
    if (action instanceof IConcatLocalizationItemsAction) {
        return {
            ...state,
            ...action.payload.localizationItems,
        };
    } else if (action instanceof IClearLocalizationItemsAction) {
        return EMPTY_OBJECT;
    } else {
        return state;
    }
};

export const reducer: Reducer<Ii18nState> = combineReducers({
    localeCode,
    supportedLanguages,
    localizationItems,
});
